<template>
  <NuxtLayout>
    <div class="editorial-info-page">
      <EditorialPageHeader
        title="Individual tutoring"
        description="One-on-one guidance to help you improve your testing practices."
        image="/2023-12-08_11-20-18_bga48t.png"
        alt="Two people working through testing concepts together"
      >
        <p class="service-intro">
          I have a decade of experience teaching hundreds of developers and testers. Whether you
          are starting with test automation or looking to level up, I'm ready to help.
        </p>
        <ActionButton to="https://cal.com/filiphric/tutoring-session">Book a session</ActionButton>
      </EditorialPageHeader>
      <section class="service-details" aria-labelledby="tutoring-expectations">
        <h2 id="tutoring-expectations">What to expect</h2>
        <ul class="editorial-service-list">
          <li>One-on-one sessions focused on your specific testing challenges</li>
          <li>Hands-on guidance with your actual codebase and testing suite</li>
          <li>Tailored guidance on best practices for test architecture and maintenance</li>
          <li>Strategies for improving test reliability and performance</li>
          <li>Practical solutions for common (and uncommon) testing pitfalls</li>
        </ul>
      </section>
    </div>
  </NuxtLayout>
</template>
